import React from 'react';
import { Box, Grid, Tabs, Tab } from "@material-ui/core";
import InternetTab from "../../assets/images/internet-tab.svg";
import InternetActive from "../../assets/images/internetActive.svg";
import GhabzActive from "../../assets/images/ghabzActive.svg";
import ChargeIcon from "../../assets/images/charge.svg";
import ChargeIconActive from "../../assets/images/chargeActive.svg";
import giftCard from "../../assets/images/giftCard.svg";
import giftCardActive from "../../assets/images/giftCardActive.svg";
import ghabz from "../../assets/images/ghabz.svg";
import { SetPaymentType } from "../../redux/chargePackage/actions";
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TopTabPanel = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const location = window.location.pathname
  const history = useHistory()
  const {
    payment: { type },
  } = useSelector(({ payment }: any) => ({
    payment,
  }));

  const handleType = (event: any, newValue: number) => {
    dispatch(SetPaymentType(newValue));
    if (location !== "/")
      history.push("/")
  };

  return (
    <Grid container justifyContent="center">
      <Grid item className={classes.responsiveBreak} xs={12} md={6} lg={5}>
        {/* @ts-ignore */}
        <Box display="flex" justifyContent="center" className="w-100">
          <Tabs
            value={type}
            onChange={handleType}
            aria-label="simple tabs example"
            className="w-100 center tab-container"
          >
            <Tab
              className="TabFont"
              icon={
                <img
                  src={type === 0 ? InternetActive : InternetTab}
                  width="60px"
                  height="60px"
                  className={`tabCustom ${type === 0 && "tabCustomActive"}`}
                />
              }
              label="بسته اینترنت"
              {...a11yProps(0)}
              style={{ order: "2" }}
            />
            <Tab
              className="TabFont"
              icon={
                <img
                  src={type === 1 ? ChargeIconActive : ChargeIcon}
                  width="60px"
                  height="60px"
                  className={`tabCustom ${type === 1 && "tabCustomActive"}`}
                />
              }
              label="شارژ مستقیم"
              {...a11yProps(1)}
              style={{ order: "1" }}
            />
            {/* gift card && ghabz */}

            <Tab
              
              className="TabFont"
              icon={
                <img
                  src={type === 2 ? giftCardActive : giftCard}
                  width="60px"
                  height="60px"
                  className={`tabCustom gift ${type === 2 && "tabCustomActive"
                    }`}
                />
              }
              style={{ order: "4" }}
              label="گیفت کارت"
              {...a11yProps(2)}
            />

            <Tab
              className="TabFont"
              icon={
                <img
                  src={type === 3 ? GhabzActive : ghabz}
                  width="60px"
                  height="60px"
                  className={`tabCustom ${type === 3 && "tabCustomActive"}`}
                />
              }
              style={{ order: "3" }}
              label="قبض"
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>
      </Grid>
    </Grid>
  );
};

export default TopTabPanel;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    responsiveBreak: {
      [theme.breakpoints.only("md")]: {},
    },
    warning: {
      width: "100%",
      height: "calc(100vh - 70px)",
      margin: "0 auto",
      backgroundColor: "#0000009c",
      zIndex: 9999,
      position: "absolute",
    },
    warningText: {
      color: "#ffffff",
      textAlign: "center",
      fontSize: "37px",
      zIndex: 99999,
      opacity: "1!important",
      marginTop: "25vh",
    },
  })
);
